import { Navigate, useOutlet } from "react-router-dom";

export const ProtectedLayout = () => {
  const user = JSON.parse(localStorage.getItem("user_data_admin"));
  const outlet = useOutlet();

  if (!user) {
    return <Navigate to="/login" />;
  }

  return <div>{outlet}</div>;
};
